export default "__VITE_ASSET__DCJhpOg$__"